export default (theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        overflow: 'hidden',
        width: '100%',
    },
    tableArea: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        minHeight: 0,
        width: '100%',
        marginBottom: 12,
    },
    companyList: {
        flex: 1,
        minHeight: 0,
        width: '100%',
        height: '100%',
        '& .ag-root-wrapper': {
            height: '100%',
        },
        '& .ag-header-viewport': {
            overflow: 'hidden !important',
        },
        '& .ag-header': {
            borderBottom: `1px solid ${theme.colors.grey[200]}`,
        },
        '&.ag-theme-balham': {
            '& .ag-header-row:first-child .ag-header-cell': {
                paddingLeft: 16,
                paddingRight: 16,
            },
            '& .ag-cell': {
                ...theme.typography.body,
            },
        },
        '& .ag-row': {
            borderBottom: `1px solid ${theme.colors.grey[100]}`,
        },
        '& .ag-row:hover': {
            backgroundColor: theme.colors.grey[50],
        },
        '& .ag-cell.company-list-cell--checkbox-disabled': {
            color: `${theme.colors.textLight.disabled} !important`,
            '& .w5-cell, & .w5-text-cell': {
                color: `${theme.colors.textLight.disabled} !important`,
            },
        },
        '& .w5-cell-checkbox--disabled': {
            cursor: 'not-allowed',
            opacity: 0.5,
            pointerEvents: 'auto',
        },
        '& .w5-cell-checkbox__svg-container svg use': {
            fill: `${theme.colors.actionMinor[400]} !important`,
        },
        '& .w5-cell-checkbox[data-ischecked="true"] .w5-cell-checkbox__svg-container svg use': {
            fill: `${theme.colors.actionMinor[500]} !important`,
        },
    },
    companyListHidden: {
        opacity: 0,
    },
    companyIdCell: {
        color: theme.colors.utility.textSecondary,
        '&.company-list-cell--checkbox-disabled': {
            color: `${theme.colors.textLight.disabled} !important`,
            '& .w5-cell, & .w5-text-cell': {
                color: `${theme.colors.textLight.disabled} !important`,
            },
        },
    },
    confirmButtonTrigger: {
        display: 'inline-flex',
    },
    footerActions: {
        display: 'flex',
        flexShrink: 0,
        justifyContent: 'flex-end',
        marginTop: 16,
        width: '100%',
    },
    searchRow: {
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        width: '100%',
        marginBottom: 8,
    },
    searchBar: {
        flex: 1,
        minWidth: 0,
        width: '100%',
        maxWidth: 224,
    },
    selectedCount: {
        flexShrink: 0,
        whiteSpace: 'nowrap',
        padding: '0 24px',
    },
    header: {
        flexShrink: 0,
        textAlign: 'left',
        marginBottom: 8,
    },
    selectionHint: {
        textAlign: 'center',
        '& a': {
            fontWeight: 500,
        },
    },
});
